import { render, staticRenderFns } from "./blank.vue?vue&type=template&id=e093c20a&scoped=true"
import script from "./blank.vue?vue&type=script&lang=js"
export * from "./blank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e093c20a",
  null
  
)

export default component.exports